import "./EditorView.css"
import {observer} from "mobx-react-lite";
import GerberFileEditor from "./editor/GerberFileEditor";
import React, {useEffect, useState} from "react";

const HEADER_HEIGHT = 50;
const FOOTER_HEIGHT = 50;
const LEFT_SIDE_WIDTH = 270;
const RIGHT_SIDE_WIDTH = 270;

function EditorView() {
    const [sett, setSett] = useState({
        w: 900,
        h: 600
    })

    // dom related staff
    const editorFrameRef = React.useRef<HTMLDivElement>(null)

    useEffect(() => {
        const editorFrame = editorFrameRef.current;
        if (editorFrame != null) {
            const parentElement: Element = (editorFrame.parentNode!!) as Element
            setSett({
                w: parentElement.clientWidth,
                h: parentElement.clientHeight
            })
            window.addEventListener("resize", handleResize)
            document.body.style.overflow = "hidden";
            return () => {
                window.removeEventListener("resize", handleResize)
                document.body.style.overflow = "scroll"
            };
        } else {
            console.error("error on initialize editor")
        }
    }, []);

    function handleResize(e: any) {
        setSett({
            w: document.body.clientWidth - (LEFT_SIDE_WIDTH + RIGHT_SIDE_WIDTH),
            h: document.body.clientHeight - (HEADER_HEIGHT + FOOTER_HEIGHT)
        })
        if (e.cancelable) {
            e.preventDefault()
        }
    }

    return <>
        <div ref={editorFrameRef} style={{width: sett.w, height: sett.h}} className={"editor-frame"}>
            <GerberFileEditor
                w={sett.w}
                h={sett.h}
            />
        </div>
    </>
}

export default observer(EditorView)